import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

const PayBackDetection = () => {
  const params = useParams()
  const navigate = useNavigate();
  useEffect(() => {
    
    const payReferenceStorage = localStorage.getItem("payRef")
    if (payReferenceStorage) {
      // alert(payReferenceStorage)
      if (payReferenceStorage === "wizard") {
        navigate(`/signupWizard/payBack/${params.id}`)
      }
      if (payReferenceStorage === "panel") {
        navigate(`/payBack/${params.id}`)
      }

    } else {
      navigate(`/invoice`)

    }
  }, [])
  return null
}


export default PayBackDetection
